// Mock data for "Gérard Trèves - La Tortue de Compostelle"
// NOTE: All data here is MOCKED for the frontend-only teaser.

export const IMAGES = {
  heroTrail: "https://images.unsplash.com/photo-1641218356058-1a8988a5135b",
  marker: "https://images.unsplash.com/photo-1723400770637-67db0e7fe294",
  lonePilgrim: "https://images.unsplash.com/photo-1529003532648-93cc0f57b7eb",
  autumnTrail: "https://images.unsplash.com/photo-1603561095848-4878d84bd726",
  goldenForest: "https://images.unsplash.com/photo-1445711005973-54fe2a103826",
  mountainFigure: "https://images.unsplash.com/photo-1521283937490-1de9cec416ba",
  sunrisePilgrims: "https://images.unsplash.com/photo-1660296146402-ce70cb473615",
  sunriseWalker: "https://images.unsplash.com/photo-1424169292451-7c28a6053189",
  bookCover: "/images/book-cover.webp",
  bookCover3d: "/images/book-3d.webp",
  authorPortrait: "/images/author-portrait.webp",
  esperancePoster: "/images/esperance-jeunesse.webp",
};

export const SITE = {
  title: "La Tortue de Compostel'",
  brand: "Gérard — La Tortue de Compostel'",
  subtitle: "Gérard Trèves",
  tagline: "Marcher pour apprendre à aimer",
  heroKicker: "GÉRARD — LA TORTUE DE COMPOSTEL'",
  heroTitle: "4 000 km pour apprendre à aimer.",
  heroSubtitle:
    "Découvrez l'histoire, les rencontres et le parcours de Gérard sur les chemins de Saint-Jacques-de-Compostelle.",
  heroLead:
    "SAINT-JACQUES-DE-COMPOSTELLE — 4000 km à pied à la découverte de soi et des autres.",
  amazonUrl:
    "https://www.amazon.fr/Marcher-pour-apprendre-%C3%A0-aimer/dp/2266233718",
  youtubeChannel: "https://www.youtube.com/channel/UCxO8qapUpD5IuX543cart-g",
};

export const STATS = [
  { value: "4000", label: "kilomètres à pied" },
  { value: "200", label: "jours de marche" },
  { value: "5", label: "millions de pas" },
];

export const ACHIEVEMENTS = [
  { count: 4000, suffix: " KM", label: "parcourus à pied" },
  { value: "Compostelle", label: "une aventure humaine" },
  { value: "1 livre", label: "Marcher pour apprendre à aimer" },
  { value: "Une vie", label: "faite de rencontres et de dépassement" },
];

export const CTA_SECTION = {
  title: "Chaque chemin raconte une histoire.",
  subtitle: "Découvrez celle de Gérard.",
};

export const STORY = {
  quote:
    "L'aller c'est la découverte, le retour l'acceptation de soi dans la rencontre avec l'autre.",
  paragraphs: [
    "En 2000, Gérard a entrepris de faire le Chemin de Saint-Jacques-de-Compostelle. L'année suivante il repart sur le Chemin mais en sens inverse, malgré son handicap provoqué par la poliomyélite qui le fait avancer très lentement et lui vaut d'être surnommé « Gérard la Tortue », « Le pèlerin la Tortue de Compostelle ».",
    "À son retour, il quitte le monde des affaires où il côtoyait les grandes fortunes de ce monde, car ses priorités ont changé. Désormais il va se consacrer à sa grande famille, ses amis, et aux rencontres que la Providence met sur son chemin de vie, et devenir un pèlerin « témoin », car le Chemin a changé sa vie et il est persuadé qu'il pourra en changer d'autres. Pourquoi pas la vôtre ?",
    "Il est désireux de faire partager son expérience du Chemin de Compostelle et aussi d'aider les personnes qui se cherchent, qui dépriment, à prendre la décision de PARTIR, pour quelques jours ou plus selon leurs possibilités afin de répondre à l'appel du Chemin après avoir lu son ouvrage « Marcher pour apprendre à aimer », qui est le récit bouleversant de sa « rédemption ».",
    "Les droits d'auteur et les bénéfices des ventes de son livre furent reversés intégralement au Fonds de dotation Espérance Jeunesse, en soutien à la Fondation d'Auteuil durant plusieurs années. Aujourd'hui, suite à la disparition d'un être cher, il vient en aide à la recherche médicale.",
  ],
};

export const BOOK = {
  title: "Marcher pour apprendre à aimer",
  rating: 4.4,
  ratingLabel: "Note moyenne des lecteurs sur Amazon",
  pullQuote: "« Rien ne sert de courir, il faut partir à point. »",
  description:
    "Gérard Trèves, dit La Tortue, applique avec célérité cet adage sur les routes du mythique pèlerinage de Saint-Jacques-de-Compostelle. Avec sa gouaille de Marseillais, il livre au fil des pages les raisons d'une quête spirituelle et personnelle. Le récit profondément humain de 112 jours de marche. 112 jours d'une renaissance. Du défi à l'acte de foi, voici l'histoire d'un homme parti marcher pour, finalement, apprendre à aimer.",
  editor: "Éditions Pocket",
};

export const VIDEOS = [
  {
    id: "v1",
    title: "Voyage Retour",
    subtitle: "« À contre-courant »",
    youtubeId: "34hWcdwiMZ4",
    description:
      "Film de Nicolas Folliet réalisé pour la télévision nationale « Montagne TV ». Aujourd'hui Nicolas Folliet offre ses droits d'auteur de ce film à Espérance Jeunesse.",
  },
  {
    id: "v2",
    title: "Voyage Aller",
    subtitle: "Diaporama des étoiles",
    youtubeId: "NuRdKlSkDoM",
    description:
      "Diaporama de 52 minutes « Fleurir le Chemin des étoiles par nos gestes d'amour », à partager en famille, entre amis ou même dans la solitude.",
  },
  {
    id: "v3",
    title: "Voyage Fraternel",
    subtitle: "« Chemin d'Espérance et d'Amour »",
    youtubeId: "NZ6lJSqhQvU",
    description:
      "Notre Chemin redécouverte pour moi et découverte pour mon frère de cœur de l'Île Maurice. Chemin de rencontres et de surprises sur la route de Compostelle.",
  },
  {
    id: "v4",
    title: "À la rencontre des lecteurs",
    subtitle: "Gérard présente son livre",
    youtubeId: "IBPEkJVzVGo",
    description:
      "Gérard Trèves à la rencontre de ses lecteurs lors d'un reportage autour de son livre : un moment de partage et d'échange autour du Chemin de Compostelle.",
  },
  {
    id: "v5",
    title: "Une aventure humaine",
    subtitle: "Sur le chemin de Compostelle",
    youtubeId: "AgwYIo88Ykc",
    description:
      "Partez sur le chemin de Compostelle aux côtés de Gérard Trèves : une aventure faite de marche, de rencontres, de paysages et de moments de réflexion.",
  },
];

// Vidéos téléversées par Gérard — à compléter prochainement.
// Pour ajouter une vidéo : { id, title, description, src (URL du fichier mp4), poster (image) }
export const UPLOADED_VIDEOS = [];


export const TESTIMONIALS = [
  {
    name: "Jean (Crabe)",
    text:
      "Dans ton témoignage, par quelques historiettes, tu approches en sensibilité un certain Saint-Exupéry. Ce qui marque les nombreuses phrases de ton périple est le retour aux sources de la fraternité, de l'amour et du souci de l'autre.",
  },
  {
    name: "Anne-Sophie",
    text: "J'ai ri, j'ai pleuré et j'ai souffert avec toi en suivant ton Chemin d'Amour.",
  },
  {
    name: "Alexandra",
    text:
      "Votre livre est un enchantement, un plaisir quotidien que j'aime parcourir au rythme de vos kilomètres.",
  },
  {
    name: "Louise",
    text: "Un grand bravo et un grand merci pour ton livre, je te dois une de mes plus belles insomnies.",
  },
];

export const OTHER_BOOKS = [
  {
    title: "Guide spirituel de la Voie du Puy-en-Velay",
    detail: "Sur les Chemins de Saint-Jacques — Éditions Salvator — Paru en 2021",
    cover: "/images/livre-guide.webp",
    link: "https://livre.fnac.com/a15170823/Gaele-De-La-Brosse-Guide-spirituel-de-la-voie-du-Puy-en-Velay",
  },
  {
    title: "Marcher et Renaître",
    detail: "Auteur : André Dréan — Paru en 2021",
    cover: "/images/livre-marcher-renaitre.webp",
    link: "https://livre.fnac.com/a13720211/Andre-Drean-Marcher-et-renaitre",
  },
];

export const DONATION = {
  title: "Pour l'enfance défavorisée, aidez-nous par un petit don",
  paragraphs: [
    "L'appel du Camino m'a offert la création en 2007 d'une association : « Espérance Jeunesse » — pour l'enfance défavorisée.",
    "Nous avons alors créé « Ose ton rêve » avec la Fondation des Apprentis d'Auteuil. Plus de 200 jeunes ont vu se concrétiser leurs rêves.",
  ],
  address: "Espérance Jeunesse, 285 rue Amélie Gex, 73190 Challes-les-Eaux",
  presets: [10, 25, 50, 100],
};


export const JOURNEY = {
  intro: {
    eyebrow: "Gérard Trèves",
    title: "La Tortue de Compostelle",
    lines: [
      "Il y a des chemins que l'on emprunte pour avancer.",
      "Et d'autres qui nous transforment pour toujours.",
    ],
    paragraphs: [
      "Gérard Trèves, surnommé La Tortue de Compostelle, est un homme au parcours rare : ancien champion du monde de parachutisme, auteur, pèlerin et témoin d'une aventure profondément humaine.",
      "Après une vie marquée par le dépassement de soi, les rencontres et les épreuves, il choisit un jour de prendre la route vers Saint-Jacques-de-Compostelle. Un chemin de lenteur, de foi, de réflexion et d'amour, parcouru malgré les difficultés physiques laissées par la poliomyélite.",
      "Son histoire n'est pas seulement celle d'un homme qui marche. C'est celle d'un homme qui apprend à ralentir, à écouter, à rencontrer et à aimer.",
    ],
  },
  sections: [
    {
      title: "Un parcours hors du commun",
      image: IMAGES.mountainFigure,
      paragraphs: [
        "Avant d'être connu comme La Tortue de Compostelle, Gérard Trèves a d'abord connu le ciel.",
        "Passionné de parachutisme, il devient champion du monde de précision d'atterrissage en 1962. Une performance exceptionnelle qui témoigne déjà de son courage, de sa discipline et de sa détermination.",
        "Mais la vie ne se résume pas aux victoires. Avec le temps, Gérard comprend que les plus grands défis ne se gagnent pas toujours dans la vitesse, la compétition ou la réussite extérieure.",
        "Parfois, le vrai combat commence lorsque l'on accepte de marcher lentement.",
      ],
    },
    {
      title: "Le Chemin de Compostelle",
      image: IMAGES.sunrisePilgrims,
      paragraphs: [
        "Le Chemin de Saint-Jacques-de-Compostelle devient pour Gérard Trèves bien plus qu'un itinéraire.",
        "C'est une aventure intérieure. Une traversée humaine. Une rencontre avec soi-même et avec les autres.",
        "Surnommé La Tortue à cause de son rythme lent, Gérard transforme cette lenteur en force. Là où beaucoup cherchent à aller vite, lui rappelle que chaque pas compte.",
        "Sur les routes de Compostelle, il découvre que marcher, ce n'est pas seulement avancer avec ses jambes. C'est aussi apprendre à déposer ses blessures, ses regrets, ses peurs et ses certitudes.",
      ],
    },
    {
      title: "Marcher pour apprendre à aimer",
      image: IMAGES.autumnTrail,
      paragraphs: [
        "Dans son livre « Marcher pour apprendre à aimer », Gérard Trèves partage le récit de cette transformation.",
        "À travers son témoignage, il invite chacun à se poser les bonnes questions : Pourquoi continuer à courir ? Que cherchons-nous vraiment ? Et si le chemin le plus important était celui qui nous ramène à l'essentiel ?",
        "Ce livre s'adresse à celles et ceux qui traversent une période de doute, de fatigue, de remise en question — ou simplement à tous ceux qui ressentent l'appel du Chemin.",
        "Ce n'est pas seulement un récit de marche. C'est une invitation à vivre autrement.",
      ],
    },
    {
      title: "Une leçon de vie",
      image: IMAGES.sunriseWalker,
      paragraphs: [
        "L'histoire de Gérard Trèves nous rappelle une chose simple : on peut avancer lentement et aller très loin.",
        "Son parcours parle de courage, de foi, d'humilité, de transmission et d'amour. Il nous montre que la fragilité n'empêche pas la grandeur, et que les épreuves peuvent devenir des chemins de lumière.",
        "À travers ses pas, ses rencontres et son témoignage, Gérard continue d'inspirer celles et ceux qui cherchent un sens, une direction ou une nouvelle manière d'avancer.",
      ],
    },
  ],
  quote:
    "Avancer lentement, ce n'est pas reculer. C'est parfois la seule manière d'aller vraiment au bout de soi-même.",
  about:
    "Gérard Trèves, dit La Tortue de Compostelle, est un auteur, ancien champion du monde de parachutisme et pèlerin de Saint-Jacques-de-Compostelle. Marqué par la poliomyélite dans son enfance, il avance lentement, mais transforme cette lenteur en message de force et d'espérance. À travers son livre « Marcher pour apprendre à aimer », il partage une aventure humaine et spirituelle autour du Chemin, de la rencontre et de la transformation intérieure.",
};

export const CONTACT = {
  intro:
    "Une question, un mot d'encouragement, un projet de rencontre ou de conférence ? Écrivez à Gérard, chaque message est lu avec attention.",
  email: "gerardlatortuedecompostel@gmail.com",
  associationAddress:
    "Espérance Jeunesse, 285 rue Amélie Gex, 73190 Challes-les-Eaux",
};

export const LEGAL = {
  editor: "Site édité par Gérard Trèves — « La Tortue de Compostel' ».",
  contactEmail: "gerardlatortuedecompostel@gmail.com",
  hosting:
    "Hébergement : ce site est hébergé par son prestataire d'hébergement web (coordonnées de l'hébergeur disponibles sur demande).",
  paragraphs: [
    "Directeur de la publication : Gérard Trèves.",
    "L'ensemble des contenus (textes, photographies authentiques, vidéos) présents sur ce site est protégé par le droit d'auteur. Toute reproduction, même partielle, est interdite sans autorisation préalable.",
    "Données personnelles (RGPD) : ce site ne propose pas de formulaire de collecte de données. Pour toute demande relative à vos données personnelles (accès, rectification, suppression, opposition), vous pouvez écrire à l'adresse de contact ci-dessous.",
    "Cookies : ce site utilise, uniquement avec votre consentement, des cookies de mesure d'audience (PostHog) et l'affichage de contenus externes (vidéos YouTube). Aucun cookie publicitaire n'est utilisé. Vous pouvez accepter, refuser ou modifier vos choix à tout moment via le lien « Gérer mes cookies » ou la Politique de cookies (/politique-cookies).",
  ],
};
